import type { ArtworkRecord } from '../../../../../packages/contracts/src/search.js';
import { React } from '../../shared/react.js';
import { ArtworkImage } from '../../shared/ui/ArtworkImage.js';
import { Icon } from '../../shared/icons.js';

function dateLabel(artwork: ArtworkRecord): string {
  if (artwork.objectDate) return artwork.objectDate;
  if (artwork.year !== null) return String(artwork.year);
  return 'Date unknown';
}

export function FeaturedMatchNode(props: {
  readonly artwork: ArtworkRecord;
  readonly queryText: string;
  readonly label: 'Closest available' | 'Best match';
  readonly selected: boolean;
  readonly onSelect: () => void;
}) {
  const style = {
    '--featured-color': props.artwork.clusterColor
  } as any;
  const className = `featured-match-node${props.selected ? ' is-selected' : ''}`;

  return (
    <button
      type="button"
      data-artwork-id={props.artwork.id}
      className={className}
      style={style}
      onClick={props.onSelect}
      aria-label={`${props.label}: ${props.artwork.title} by ${props.artwork.creator}. Query: ${props.queryText}`}
      aria-pressed={props.selected}
    >
      <span className="featured-match-node__spark" aria-hidden="true"><Icon name="spark" size={19}/></span>
      <span className="featured-match-node__label">{props.label}</span>
      <span className="featured-match-node__border">
        <span className="featured-match-node__frame">
          <span className="featured-match-node__image">
            <ArtworkImage
              src={props.artwork.thumbnailUrl ?? props.artwork.imageUrl ?? props.artwork.detailImageUrl}
              alt=""
              eager priority sizes="(max-width: 680px) 110px, 160px"
              fallbackLabel="Met"
              width={props.artwork.imageWidth}
              height={props.artwork.imageHeight}
              dominantColor={props.artwork.dominantColor}
            />
          </span>
          <span className="featured-match-node__copy">
            <strong>{props.artwork.title}</strong>
            <small>{props.artwork.creator || 'Unknown maker'}</small>
            <small>{dateLabel(props.artwork)}</small>
            <em>The Metropolitan Museum of Art</em>
          </span>
        </span>
      </span>
      <span className="featured-match-node__rank" aria-hidden="true">1</span>
    </button>
  );
}
